import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '../components/components.module';
import { ChildComponentsModule } from '../components/child-components.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgChartsModule } from 'ng2-charts';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { OfflineCenterComponent } from './offline-center.component';
// import { LightboxModule } from 'ngx-lightbox';

export const routes: any[] = [
  {
    path: '', component: OfflineCenterComponent, children: [
      { path: 'chandigarh', loadChildren: () => import('../chandigarh/chandigarh.module').then(m => m.ChandigarhModule) },
      { path: 'patna', loadChildren: () => import('../patna/patna.module').then(m => m.PatnaModule) },
      { path: 'jaipur', loadChildren: () => import('../jaipur/jaipur.module').then(m => m.JaipurModule) },
      { path: 'surat', loadChildren: () => import('../surat/surat.module').then(m => m.SuratModule) },
      { path: 'kolkata', loadChildren: () => import('../kolkata/kolkata.module').then(m => m.KolkataModule) },
      { path: 'ranchi', loadChildren: () => import('../ranchi/ranchi.module').then(m => m.RanchiModule) },
      { path: 'srinagar', loadChildren: () => import('../srinagar/srinagar.module').then(m => m.SrinagarModule) },
      { path: 'jammu', loadChildren: () => import('../jammu/jammu.module').then(m => m.JammuModule) },
      { path: 'varanasi', loadChildren: () => import('../varanasi/varanasi.module').then(m => m.VaranasiModule) },
      { path: 'jamshedpur', loadChildren: () => import('../jamshedpur/jamshedpur.module').then(m => m.JamshedpurModule) },
      { path: 'prayagraj', loadChildren: () => import('../prayagraj/prayagraj.module').then(m => m.PrayagrajModule) },
      { path: 'nagpur', loadChildren: () => import('../nagpur/nagpur.module').then(m => m.NagpurModule) },
      { path: 'goa', loadChildren: () => import('../goa/goa.module').then(m => m.GoaModule) },
      { path: 'agra', loadChildren: () => import('../agra/agra.module').then(m => m.AgraModule) },
      { path: 'indore', loadChildren: () => import('../indore/indore.module').then(m => m.IndoreModule) },
      { path: 'vadodara', loadChildren: () => import('../vadodara/vadodara.module').then(m => m.VadodaraModule) },
      { path: 'bhopal', loadChildren: () => import('../bhopal/bhopal.module').then(m => m.BhopalModule) },
      { path: 'bhubaneswar', loadChildren: () => import('../bhubaneswar/bhubaneswar.module').then(m => m.BhubaneswarModule) },
      { path: 'raipur', loadChildren: () => import('../raipur/raipur.module').then(m => m.RaipurModule) },
      { path: 'ludhiana', loadChildren: () => import('../ludhiana/ludhiana.module').then(m => m.LudhianaModule) },
      { path: 'kochi', loadChildren: () => import('../kochi/kochi.module').then(m => m.KochiModule) },
      { path: 'jhansi', loadChildren: () => import('../jhansi/jhansi.module').then(m => m.JhansiModule) },
      { path: 'thane', loadChildren: () => import('../thane/thane.module').then(m => m.ThaneModule) },
      { path: 'rajkot', loadChildren: () => import('../rajkot/rajkot.module').then(m => m.RajkotModule) },
      { path: 'lucknow', loadChildren: () => import('../lucknow/lucknow.module').then(m => m.LucknowModule) },
      { path: 'siliguri', loadChildren: () => import('../siliguri/siliguri.module').then(m => m.SiliguriModule) },
      { path: 'gurgaon', loadChildren: () => import('../gurugram/gurugram.module').then(m => m.GurugramModule) },
      { path: 'noida', loadChildren: () => import('../noida/noida.module').then(m => m.NoidaModule) },


    ]
  },
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ChildComponentsModule,
    ComponentsModule,
    MatButtonModule,
    MatDialogModule,
    MatSnackBarModule,
    MatMenuModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatTabsModule,
    MatButtonToggleModule,
    SlickCarouselModule,
    // LightboxModule,
    FormsModule,
    ReactiveFormsModule,



    NgChartsModule

  ],
  declarations: [
    OfflineCenterComponent,
  ],

  entryComponents: [
  ]

})
export class OfflineCenterModule { }